import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
  TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { TourService } from "@services/tour.service";
import { PageViewService } from "../../services/page-view.service";

@Component({
  selector: "app-page-view-nav",
  templateUrl: "./page-view-nav.component.html",
  styleUrls: ["./page-view-nav.component.scss"],
})
export class PageViewNavComponent implements OnInit {
  public isHidden: boolean;
  public breadcrumbs: AppPageViewBreadcrumbs[] = [];
  @Input() links: AppPageViewLinks[] = [];
  @Input() showSidebar = true;
  @Input() avoidLinksPattern: string[] = []; // Array of patterns that identify segments that should not be links
  @ViewChildren("left-menu-button-admin") adminButton: QueryList<ElementRef>;

  stickyButtonContent: TemplateRef<any> | null = null;
  stickyButtonCallback: Function | null = null;

  constructor(
    private router: Router,
    private tourService: TourService,
    private cd: ChangeDetectorRef,
    private pageViewService: PageViewService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((e) => {
      this.drawBreadcrumbs();
    });

    this.pageViewService.stickyButtonContent$.subscribe((content) => {
      this.stickyButtonContent = content;
    });
  }

  ngOnChanges(changes) {
    if (changes) {
      this.drawBreadcrumbs();
    }
  }

  drawBreadcrumbs() {
    let route = this.router.url.split(/\//);
    if (!this.links?.length) return;

    this.breadcrumbs = route.reduce(
      (acc, path, i) => {
        if (!path) return acc;

        path = path.split("?")[0];
        let route = i === 1 ? `/${path}` : `${acc.previousPath}/${path}`;
        acc.previousPath += `/${path}`;

        let text: any = path.split(" ");
        let link = this.links.find(
          (link) => link.route === path || link.path === path
        );

        text = link?.text || text.join("-").split("?")[0];

        if (link) route = link.directRoute || link.route || route;

        // check if this segment matches any of the avoid link patterns
        const shouldAvoidLink = this.avoidLinksPattern.some((pattern) =>
          new RegExp(pattern).test(route)
        );

        acc.breadcrumbs.push({
          ...link,
          link: route,
          text,
          avoidLink: link?.avoidLink || shouldAvoidLink,
        });

        return acc;
      },
      { breadcrumbs: [] as AppPageViewBreadcrumbs[], previousPath: "" }
    ).breadcrumbs;
    this.cd.detectChanges();
  }
  inRoute(route) {
    const regex = new RegExp("/" + route + "(\\?[^/]+)?(?=/|$)");
    if (this.router.url) return this.router.url.split("?")[0].match(regex);
    else return false;
  }
}

export interface AppPageViewBreadcrumbs {
  text: string;
  link: string;
  avoidLink:boolean
}

export interface AppPageViewLinks {
  text: string;
  route: string;
  translation_key?: string;
  directRoute?: string;
  hidden?: boolean;
  path?: string;
  tourId?: string;
  stepId?: string;
  position?: string;
  avoidLink?:boolean
}
